import React from "react";
import { Link } from "react-router-dom";
import { UserCog } from "lucide-react";
import { useAppState } from "../hooks/useAppState";
import TopBar from "../components/layout/TopBar";
import AccountantAccessPanel from "../components/commercialista/AccountantAccessPanel";

export default function AccountantSettingsPage() {
  const { user, darkMode, toggleDarkMode, isSynced } = useAppState();

  return (
    <div className={`min-h-screen transition-colors ${darkMode ? "bg-neutral-950 text-white" : "bg-neutral-50 text-neutral-900"}`}>
      <TopBar
        user={user}
        notificationsCount={0}
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
        onUploadLogo={() => {}}
        isSynced={isSynced}
      />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 pb-12">
        <div className="mt-6 mb-4">
          <h1 className={`text-xl font-semibold flex items-center gap-2 ${darkMode ? "text-white" : "text-neutral-900"}`}>
            <UserCog className="w-5 h-5 text-forfy-500" />
            Accesso Commercialista
          </h1>
          <p className={`text-sm mt-1 ${darkMode ? "text-neutral-400" : "text-neutral-600"}`}>
            Genera un link sicuro e temporaneo da condividere con il tuo commercialista: potrà consultare le fatture,
            scaricare i totali e caricare F24 e dichiarazioni, senza bisogno di un account.
          </p>
        </div>

        <div className="mt-6">
          <AccountantAccessPanel darkMode={darkMode} />
        </div>

        <div className="mt-6 flex justify-end">
          <Link
            to="/settings"
            className={`px-4 py-2 rounded-lg border text-sm ${
              darkMode
                ? "border-neutral-700 bg-neutral-800 text-neutral-400 hover:bg-neutral-700"
                : "border-neutral-200 bg-white text-neutral-700 hover:bg-neutral-50"
            }`}
          >
            Torna al profilo
          </Link>
        </div>
      </main>
    </div>
  );
}
